import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { DepartmentState } from './department.state';

export namespace DepartmentSelectors {
  export const department = (state: AppState): DepartmentState => state.departments;

  // eslint-disable-next-line
  export function getState() {
    return createSelector(department, (state: DepartmentState) => ({
      departments: state.departments,
    }));
  }
}
